import { createContext } from 'react';
import type { PluginApiClient } from './types';

export const PluginApiContext = createContext<PluginApiClient | null>(null);
